import { postCoreDataSecurityAuditTrailExportSlice } from './post';

export const { requestPostCoreDataSecurityAuditTrailExport, resetPostCoreDataSecurityAuditTrailExport } =
	postCoreDataSecurityAuditTrailExportSlice.asyncActionCreators;
